module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av233-69ec72958e6a7e355de95716297d3adf.jpg";